import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: 'cs-card-header',
    templateUrl: 'cs-card-header.html',
    host: { 'class': 'card-header' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsCardHeaderComponent {
}